import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { SaveAutomationTargetPayload } from '@rossum/api-client/queues';
import { api } from '../../../../../lib/apiClient';
import { QUERY_KEY_GET_SAVED_AUTOMATION_TARGETS } from '../../core/hooks/useGetSavedAutomationTargets';

export const useSaveAutomationTargets = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['save-automation-targets'] as const,
    mutationFn: ({
      queueId,
      payloads,
    }: {
      queueId: number;
      payloads: SaveAutomationTargetPayload[];
    }) =>
      payloads.reduce(async (previousPromise, payload) => {
        await previousPromise;
        await api.request(
          endpoints.queues.saveAutomationTarget(queueId, payload)
        );
        // async function implicitly returns Promise<void>
      }, Promise.resolve()),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_GET_SAVED_AUTOMATION_TARGETS],
      });
    },
  });
};
